import React, { useEffect, useRef, useState } from 'react'
import { Line } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import Modal from '../../components/shared/modal'


ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);

export const options = {
    responsive: true,
    plugins: {
        legend: {
            display: false,
            position: 'top',
        },
        title: {
            display: false,
        },
    },
    scales: {
        xAxes: {
            display: false,
        },
        y: {
            grid: {
                color: '#646464',
            },
            ticks: {
                color: '#FFFFFF',
            }
        },
    },
    maintainAspectRatio: false,
};
export const optionsBig = {
    responsive: true,
    plugins: {
        legend: {
            display: false,
            position: 'top',
        },
        title: {
            display: false,
        },
    },
    scales: {
        xAxes: {
            display: true,
        },
        // yAxes: {
        //     display: true,
        // },
        y: {
            grid: {
                color: '#646464',
            },
            ticks: {
                color: '#646464',
            }
        },
    },
    maintainAspectRatio: true,
};


const TempPlot = ({
    plotValues,
    entityName,
    title,
}) => {
    const [openModal, setOpenModal] = useState(false)

    let lastTempPlotValue = 0

    const tempPlotValues = plotValues
        ?.filter?.(item => item[0].entity_id === entityName)
        ?.map?.(items => items.map(item => {
            const tempState = parseFloat(item.state)

            if ((tempState + 0.08) < lastTempPlotValue || (tempState - 0.08) > lastTempPlotValue) {
                lastTempPlotValue = tempState
                return tempState
            }

            return lastTempPlotValue

        }))
        ?.pop?.()

    const tempPlotDates = plotValues
        ?.filter?.(item => item[0].entity_id === entityName)
        ?.map?.(items => items.map(item => window.moment(item.last_updated).format('LLLL')))
        ?.pop?.()

    if (!tempPlotValues || tempPlotValues?.length === 0) {
        return null
    }

    const getColorByTemp = temp => {
        if (temp < 0) {
            return 'rgb(87,144,246)'
        }

        if (temp < 10) {
            return 'rgba(194,200,255,0.73)'
        }

        if (temp < 15) {
            return 'rgba(188,255,191,0.99)'
        }

        if (temp < 22) {
            return 'rgba(140,246,87,0.66)'
        }

        return 'rgb(246,87,87)'
    }

    const data = {
        labels: Array.from(Array(tempPlotValues.length).keys()),
        datasets: [
            {
                label: 'Teplota',
                data: tempPlotValues,
                pointRadius: 0,
                segment: {
                    borderColor: (ctx) => getColorByTemp(tempPlotValues[ctx.p0DataIndex]),
                }
            },
        ],
    }

    const dataBig = {
        labels: tempPlotDates,
        datasets: [
            {
                label: 'Teplota',
                data: tempPlotValues,
                pointRadius: 0,
                segment: {
                    borderColor: (ctx) => getColorByTemp(tempPlotValues[ctx.p0DataIndex]),
                }
            },
        ],
    }

    return (
        <div
            className="col-12 col-sm-6 col-md-4"
            onClick={() => setOpenModal(true)}
        >
            <div className="pt-5 position-relative" style={{ height: '100px' }}>
                <div
                    className="d-flex flex-row align-items-center justify-content-between w-100"
                    style={{
                        position: 'absolute',
                        top: '22px',
                        left: 0,
                        fontSize: '13px',
                    }}
                >
                    <div>
                        {title}
                    </div>
                    <div style={{ fontWeight: 'bold' }}>
                        {tempPlotValues[tempPlotValues.length - 1] === 'unknown' ? '?' : tempPlotValues[tempPlotValues.length - 1]} °C
                    </div>
                </div>
                <Line
                    options={options}
                    data={data}
                />
            </div>

            {openModal && (
                <Modal
                    description={title}
                    handleHideModal={() => setOpenModal(false)}
                    content={() => (
                        <div className="w-100">
                            <Line
                                options={optionsBig}
                                data={dataBig}
                            />
                        </div>
                    )}
                    dialogClass="modal-lg"
                />
            )}
        </div>
    )
}

export default TempPlot
